import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DialogBodyComponent } from './dialog-body.component';

@NgModule({
  imports: [CommonModule],
  declarations: [DialogBodyComponent],
  exports: [DialogBodyComponent],
})
export class DialogBodyModule {}
export { DialogBodyComponent } from './dialog-body.component';
